{
  "header": "Vérifiez votre téléphone cellulaire",
  "inputs": {
    "mobile-verification-code": {
      "label": "",
      "isRequired": true,
      "maxLength": 5,
      "type": "tel",
      "mask": "00000",
      "validity": [
        ["required", "Code de vérification requis", "ignore label"],
        [
          "requiredLength5",
          "Code de vérification à 5 chiffres requis",
          "ignore label"
        ]
      ]
    }
  },
  "sms": {
    "uplift": {
      "label": "<span>Saisir le <strong>code à 5 chiffres</strong> envoyé au <strong>{{phoneNumber}}</strong> via <strong>SMS</strong> par <strong>Uplift</strong>.</span>"
    },
    "flexpay": {
      "label": "<span>Saisir le <strong>code à 5 chiffres</strong> envoyé au <strong>{{phoneNumber}}</strong> via <strong>SMS</strong> de <strong>Flex Pay</strong>.</span>"
    },
    "resend-code": "Renvoyer le code",
    "check-mobile": "Veuillez vérifier l’exactitude de votre numéro de cellulaire.",
    "resend-now": "Renvoyer maintenant"
  },
  "submit": "Vérifier"
}
